import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Skills } from '../../Skills';
import type { SkillsGroup as ISkillsGroup } from '../../../types';

type SkillsGroupProps = Readonly<ISkillsGroup>;

export const SkillsGroup = ({ type, skills }: SkillsGroupProps) => (
    <Stack direction="column" gap="3">
        <Typography size="b_xs" fontWeight="bold" color="grey_900">
            {type.name.toUpperCase()}
        </Typography>
        <Skills skills={skills} />
    </Stack>
);
